import * as React from "react";
import BaseModal, { BaseModalContent } from "../BaseModal";
import PersonIcon from '@material-ui/icons/Person';
import AppealCitationForm from "../../Forms/citation/AppealCitationForm";

const AppealCitationModal=(props)=>{ 
    const {isOpenAppealCitationModal,handleCloseAppealCitationModal ,citationDetailState} = props;
   

    return(
        <> 
            <BaseModal
              title= {`Appealed Citation ${citationDetailState?.id}`}
             align="center"
             icon={<PersonIcon />}
              open={isOpenAppealCitationModal}
             onClose={handleCloseAppealCitationModal}
              maxWidth={"md"}
            >
                <BaseModalContent>
                   <AppealCitationForm handleClose={handleCloseAppealCitationModal} {...props} />
                </BaseModalContent>
            </BaseModal>
        </>
    )
}
export default AppealCitationModal;